import { render, staticRenderFns } from "./ForumsOverview.vue?vue&type=template&id=7edd3857&scoped=true"
import script from "./ForumsOverview.vue?vue&type=script&lang=ts"
export * from "./ForumsOverview.vue?vue&type=script&lang=ts"
import style0 from "./ForumsOverview.vue?vue&type=style&index=0&id=7edd3857&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edd3857",
  null
  
)

export default component.exports